import { ServiceFetch } from '../service-fetch'

export default class SaleStationModel extends ServiceFetch {
    getSaleStationBy = (data) => this.authFetch({
        url: 'sale-station/getSaleStationBy',
        method: 'POST',
        body: JSON.stringify(data),
    }) 
    getSaleStationByCode = (data) => this.authFetch({
        url: 'sale-station/getSaleStationByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })
}